/* Earth Rebirth fluid motion — scroll reveal + header shadow on scroll */
(function(){
  function onScroll(){ document.documentElement.classList.toggle('er-scrolled', window.scrollY>20); }
  window.addEventListener('scroll', onScroll, {passive:true}); onScroll();
  function tagReveals(){
    var sel='.card-wrapper, .banner__box, .collection-list__item, .section-header, .rich-text__blocks, .multicolumn-card, .product__info-container';
    document.querySelectorAll(sel).forEach(function(el){ if(!el.classList.contains('er-reveal')) el.classList.add('er-reveal'); });
  }
  function run(){
    tagReveals();
    var io=new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('er-in'); io.unobserve(e.target);} });},{threshold:.12});
    document.querySelectorAll('.er-reveal').forEach(function(el){ io.observe(el); });
  }
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded', run);

  /* Add a prominent "take the quiz" CTA into the homepage hero, pointing at the
     Just For You product-finder, so shoppers can personalize their picks up top. */
  function addQuizCta(){
    var row=document.querySelector('.erh .herobtns');
    if(!row || row.querySelector('.er-quizcta')) return;
    var a=document.createElement('a');
    a.className='er-quizcta';
    a.href='/pages/just-for-you';
    a.textContent='✨ Find your fit — take the quiz';
    row.insertBefore(a, row.firstChild);
  }
  if(document.readyState!=='loading') addQuizCta(); else document.addEventListener('DOMContentLoaded', addQuizCta);

  /* Homepage enhancements: products-first reorder, quantified impact tags, bundle add-to-cart */
  function enhanceHome(){
    var root=document.querySelector('.erh'); if(!root) return;

    /* 1) Move the Featured products up so they appear right after the hero;
          the "Where your money goes" strip then splits the page further down. */
    var shop=root.querySelector('#erh-shop'), impact=root.querySelector('#erh-impact');
    if(shop && impact && (shop.compareDocumentPosition(impact) & Node.DOCUMENT_POSITION_PRECEDING)){
      impact.parentNode.insertBefore(shop, impact);
    }

    /* 1b) Earth Rebirth name + mission as a slim bar at the very top, directly under the menu */
    if(!root.querySelector('.er-mission')){
      var mission=document.createElement('div'); mission.className='er-mission';
      mission.innerHTML='<span class="er-mission-in"><b>🌍 Earth Rebirth</b> — a 501(c)(3) nonprofit educating &amp; empowering people to take food, energy &amp; water into their own hands.</span>';
      root.insertBefore(mission, root.firstChild);
    }

    /* 2) Quantified impact tag per product — rotates wording so neighbours don't repeat */
    var ti=0;
    root.querySelectorAll('#erh-grid .card').forEach(function(card){
      var tag=card.querySelector('.itag'); if(!tag) return;
      var price=parseFloat(card.dataset.price)||0, cat=card.dataset.cat;
      var packs=Math.max(1, Math.round(price/3));
      function pick(arr){ return arr[ti % arr.length]; }
      var msg;
      if(cat==='books'){ msg=pick(['funds a free youth garden lesson','teaches a family to grow their own food','puts a garden guide in a classroom']); }
      else if(price>=38){ msg=pick(['helps build a raised garden bed','funds a season of fresh seedlings','plants a corner of a community garden']); }
      else if(price>=22){ msg=pick(['funds a community garden kit','stocks a classroom grow-station','funds a month of garden upkeep']); }
      else if(price>=14){ msg=packs+pick([' seed packs + garden tools',' seed packs for a school garden']); }
      else { msg=packs+pick([' seed packs for a community garden',' seed packs for a window garden']); }
      tag.textContent='🌱 '+msg; ti++;
    });

    /* 3) Bundle "add set to cart" buttons — drop every item in the set into the cart at once */
    var sets=[
      [36816344580256,36816259448992],
      [36816344580256,36861570252960,36815629713568],
      [36818034000032,36817993334944]
    ];
    root.querySelectorAll('.bundle').forEach(function(bundle,i){
      if(!sets[i] || bundle.querySelector('.addset')) return;
      var existing=bundle.querySelector('.addb');
      var wrap=document.createElement('div'); wrap.className='bsetbtns';
      var add=document.createElement('button'); add.type='button'; add.className='addset'; add.textContent='➕ Add set to cart';
      add.addEventListener('click',function(){
        add.textContent='Adding…'; add.disabled=true;
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({items:sets[i].map(function(id){return {id:id,quantity:1};})})})
          .then(function(r){return r.json();})
          .then(function(){ window.location.href='/cart'; })
          .catch(function(){ add.textContent="Couldn't add — try again"; add.disabled=false; });
      });
      if(existing){ existing.textContent='View set'; existing.classList.add('addb-secondary');
        existing.parentNode.insertBefore(wrap, existing); wrap.appendChild(add); wrap.appendChild(existing); }
      else { bundle.appendChild(wrap); wrap.appendChild(add); }
    });
  }
  if(document.readyState!=='loading') enhanceHome(); else document.addEventListener('DOMContentLoaded', enhanceHome);
})();
